<template>
  <the-header v-bind:titleFromProp="header" v-bind:department="department">
  </the-header>


  <whitlam-resources v-if="isWhitlam"></whitlam-resources>
  <the-resources v-else></the-resources>
</template>

<script>
import TheHeader from './layout/TheHeader.vue';
import TheResources from './pages/TheResources.vue';
import WhitlamResources from './pages/WhitlamResources.vue';

export default {
    name: 'WHITLAM',
  data() {
    return {
      header: 'Library Meeting Rooms',
      department: 'WHITLAM',
      isWhitlam: true,
    };
  },
  components: { TheHeader, TheResources, WhitlamResources },
  mounted() {
    console.log(Object. keys(this.$route.query). length);
    if(Object. keys(this.$route.query). length) {
        this.isWhitlam = false
    }
  },
  methods: {
    styles: function () {
        return {
          '$style.button': {
            'background-color': 'red',
          },
        };
    },
  },

};
</script>

<style>
.vue__time-picker .controls .char {
  color: white;
  font-size: 2em;
}

.vue__time-picker .dropdown ul li:not([disabled]).active,
.vue__time-picker .dropdown ul li:not([disabled]).active:hover,
.vue__time-picker .dropdown ul li:not([disabled]).active:focus {
  background: #00509e;
  color: #fff;
}

.vue__time-picker input.vue__time-picker-input {
  padding: 0em 0.5em;
  font-size: 0.9em;
  /* font-family: inherit; */
}

header {
  background-color: #c9c2c0;
}

@import url('https://fonts.googleapis.com/css2?family=Nanum+Gothic&display=swap');

* {
  box-sizing: border-box;
}

html {
  /* font-family: 'Roboto', sans-serif; */
}

body {
  margin: 0;
}

div {
  margin-left: auto;
  margin-right: auto;
}
</style>
